export enum ApplicationEnvironmentTypeEnum
{
    Production = 0,
    Test = 1,
    Development = 2,
    Stage = 3
}





export interface IAppDomainConfig {
    readonly environmentType: ApplicationEnvironmentTypeEnum;
    readonly domainOrigin: string;
    readonly apiOrigin: string;
}

